module.exports = __webpack_public_path__ + "img/Mutual-Trust-Bank.0a962137.jpg";